import { render, staticRenderFns } from "./BandejaInterConsultaFull.vue?vue&type=template&id=2d5d9385&scoped=true"
import script from "./BandejaInterConsultaFull.vue?vue&type=script&lang=js"
export * from "./BandejaInterConsultaFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d9385",
  null
  
)

export default component.exports